import React from "react";
import "icofont/dist/icofont.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import './styles/custom.scss';
import "./styles/colors.css";
import "./styles/responsive.css";
import "./styles/App.css";
import Header from "./components/Header";
import Banner from "./components/Banner";
import EmailInputGroup from "./components/EmailInputGroup";
import AboutSlider from "./components/AboutSlider";
import FeedbackSlider from "./components/FeedbackSlider";
import PricingTable from "./components/PricingTable";
import Footer from "./components/Footer";
import About from "./components/About";
import Services from "./components/Services";
import Team from "./components/Team";
import Portfolio from "./components/Portfolio";
import Marketing from "./components/Marketing";
import LatestNews from "./components/LatestNews";
import OurBranch from "./components/OurBranch";
import ContactUs from "./components/ContactUs";

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Header />

        <div id="home" className="section">
          <Banner />
        </div>

        <EmailInputGroup />

        <About />

        <AboutSlider />

        <Services />

        {/* <Team /> */}

        <Portfolio />

        <Marketing />

        {/* <FeedbackSlider /> */}

        {/* <PricingTable /> */}

        {/* <LatestNews /> */}

        <ContactUs />

        <OurBranch />

        <Footer />
      </div>
    );
  }
}

export default App;